import { ValidationPatterns } from "src/platform/constants";
import { DataContract } from "src/platform/data/DataContract";

import { User, LoginCredentials } from "../types/auth.types";

export class AuthDataContract implements DataContract<User> {
  name = "AuthDataContract";
  private errors: string[] = [];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validateInput(params: any): params is LoginCredentials {
    this.errors = [];
    if (!params || typeof params !== "object") {
      this.errors.push("Invalid input: must be an object");
      return false;
    }
    if (!params.email || typeof params.email !== "string") {
      this.errors.push("Email is required and must be a string");
      return false;
    }
    if (!params.password || typeof params.password !== "string") {
      this.errors.push("Password is required and must be a string");
      return false;
    }
    if (!ValidationPatterns.EMAIL.test(params.email)) {
      this.errors.push("Invalid email format");
      return false;
    }
    return true;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validateOutput(data: any): data is User {
    this.errors = [];
    if (!data || typeof data !== "object") {
      this.errors.push("Invalid user data: must be an object");
      return false;
    }
    const requiredFields = ["id", "email", "name", "onboardingCompleted"];
    for (const field of requiredFields) {
      if (!(field in data)) {
        this.errors.push(`Missing required field: ${field}`);
        return false;
      }
    }
    if (typeof data.id !== "string" || !data.id) {
      this.errors.push("User ID must be a non-empty string");
      return false;
    }
    if (typeof data.email !== "string" || !data.email) {
      this.errors.push("User email must be a non-empty string");
      return false;
    }
    if (typeof data.name !== "string" || !data.name) {
      this.errors.push("User name must be a non-empty string");
      return false;
    }
    if (typeof data.onboardingCompleted !== "boolean") {
      this.errors.push("onboardingCompleted must be a boolean");
      return false;
    }
    return true;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transformInput(params: LoginCredentials): any {
    return {
      email: params.email.toLowerCase().trim(),
      password: params.password,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transformOutput(data: any): User {
    return {
      id: data.id,
      email: data.email,
      name: data.name,
      onboardingCompleted: data.onboardingCompleted,
      createdAt: data.createdAt || new Date().toISOString(),
      updatedAt: data.updatedAt || new Date().toISOString(),
    };
  }

  getErrorMessages(): string[] {
    return this.errors;
  }
}
